export default __webpack_public_path__ + "static/media/icon.49f573b1.png";